module.exports = __webpack_public_path__ + "img/marmelaedchen-kasse-cl_xs.d8b9049c.jpg";